import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { loginUser } from '../../store/auth/authActions';
import { errorToast, isValidEmail } from '../../utils';
import { setProfile } from '../../store/profile/profileSlice';
import { useForm } from 'react-hook-form';
import { getUserProfiles } from '../../store/profile/profileActions';

const LoginForm = () => {
    const { user, loading, isLogged } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const signinUser = async (data) => {
        dispatch(loginUser({
            email: data.email,
            password: data.password
        }))
        .unwrap()
        .catch((errorData) => {
            console.log(errorData)
            errorToast(errorData.error);
        });
    };

    return (
        <form onSubmit={handleSubmit(signinUser)}>
            <h1 className='text-nt-blue text-center mb-5'>Sign In</h1>
            <div>
                <label className="block text-primary-grey text-[13px] font-medium pb-1">Email</label>
                <div className="relative">
                    <input
                        className="inputField w-full mb-8"
                        name="email"
                        placeholder="Enter your email"
                        id="email"
                        defaultValue={""}
                        {...register("email", {
                            required: "Email is required",
                            validate: (value) =>
                                isValidEmail(value) || "Please enter a valid email address",
                        })}
                        type="email"
                        required />
                </div>
                {errors.email && (
                    <span className="mt-1 block text-xs text-red-500">{errors.email.message}</span>
                )}
            </div>
            <div>
                <label className="block text-primary-grey text-[13px] font-medium pb-1">Password</label>
                <div className="relative">
                    <input
                        className="inputField w-full mb-8"
                        name="password"
                        placeholder="Enter your password"
                        id="password"
                        defaultValue={""}
                        {...register("password")}
                        type="password"
                        required />
                </div>
            </div>
            <button type="submit" className="primaryButton mb-5">
                {loading ? 'Loading...' : 'Login'}
            </button>
            <div className='text-center'>
                <p className='mb-2'>
                    <Link to='/forgot' className="link">Forgot your password ?</Link>
                </p>
            </div>
        </form>)
}

export default LoginForm;